module.exports = __webpack_public_path__ + "img/img5.8b6ce41a.svg";